import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { JwtHelperService } from "@auth0/angular-jwt";
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserRoles } from '../../app.enums';
import { AuthService } from '../../Services/auth.service';
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
    private jwtHelper: JwtHelperService,
    private authService: AuthService) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    var allowedRoles: UserRoles[] = route.data['allowedRoles'] as UserRoles[];
    return this.hasAccess(state.url, allowedRoles);
  }

  private hasAccess(url: string, allowedRoles: UserRoles[]): Observable<boolean> {
    let isAuthenticated: boolean = this.authService.isAuthenticated();
    if (isAuthenticated) {
      var accessToken = this.authService.getAccessToken();
      if (accessToken && !this.jwtHelper.isTokenExpired(accessToken)) {
        // Redirect Judge/Curator away from non-judge/curator pages to their proper dashboards
        if (this.authService.isJudge() && !url.startsWith('/judge')) {
          this.router.navigate(['/judge/dashboard']);
          return of(false);
        }
        if (this.authService.isCurator() && !url.startsWith('/curator')) {
          this.router.navigate(['/curator/dashboard']);
          return of(false);
        }

        if (!allowedRoles) {
          return of(true);
        }
        if (this.authService.isInAnyRole(allowedRoles)) {
          return of(true);
        } else {
          if (this.authService.IsSuperAdmin()) {
            this.router.navigate(['/ds-admin-dashboard']);
            return of(false);
          }
          if (this.authService.isAdministrator()) {
            this.router.navigate(['/ds-admin-dashboard']);
            return of(false);
          }
          this.router.navigate(['/dashboard']);
          return of(false);
        }
      }
    }

    if (url.endsWith('/login')) {
      return of(true);
    }

    if (isAuthenticated) {
      if (this.authService.isAdministrator() || this.authService.IsSuperAdmin()) {
        this.router.navigate(['/ds-admin-dashboard']);
        return of(false);
      }
      if (this.authService.isJudge()) {
        this.router.navigate(['/judge/dashboard']);
        return of(false);
      }
      if (this.authService.isCurator()) {
        this.router.navigate(['/curator/dashboard']);
        return of(false);
      }
      this.router.navigate(['/dashboard']);
      return of(false);
    } else {
      this.router.navigate(['/login']);
    }
    return of(false);
  }
}
